// frontend/src/notificationAxios.js
import axios from "axios";

const notificationAxios = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api.coinzetto.com/api" // Production URL
      : "http://localhost:5000/api",     // Dev URL
  withCredentials: true,
});

// Optional: attach token if needed
notificationAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default notificationAxios;
